module.exports = __webpack_public_path__ + "static/media/16.5737746d.jpg";